import { forwardRef, useEffect, useImperativeHandle, useState } from "react";
import styles from "./navigation.module.css";
import gsap from "gsap";
import ScrollToPlugin from "gsap/ScrollToPlugin";
import Text from "../text/text";
import { Photography } from "../work/work";
import Image from "../image/image";
gsap.registerPlugin(ScrollToPlugin);

export interface NavigationProps {
  containerAnimation?: gsap.core.Animation;
  photographyData: Photography[];
  author: string[];
  category: string[];
}

export interface NavigationHandle {
  updateGsapLabels: (state: { photography: string[]; ctn: string[] }) => void;
  updateProgress: (state: string) => void;
}
const Navigation = forwardRef<NavigationHandle, NavigationProps>(
  (props: NavigationProps, ref) => {
    const [gsapLabels, setGsapLabels] = useState<{
      photography: string[];
      ctn: string[];
    }>({
      photography: [],
      ctn: [],
    });
    const [progress, setProgress] = useState<string>("0%");
    useImperativeHandle(ref, () => ({
      updateGsapLabels: (state: { photography: string[]; ctn: string[] }) => {
        // console.log(state);
        setGsapLabels(state);
      },
      updateProgress: (state) => {
        setProgress(state);
      },
    }));
    useEffect(() => {
      // console.log(props.containerAnimation?.parent?.labels);
    }, [props.containerAnimation]);
    return (
      <div
        className={`${styles.ctn} shadow-v60-nav`}
        style={
          {
            "--shadow-v60-progress": progress,
          } as React.CSSProperties
        }
      >
        <div className={styles.background}></div>
        <div className={styles.progress}>
          <svg
            width="9"
            height="6"
            viewBox="0 0 9 6"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
            className={styles.arrow}
          >
            <path d="M9 0L4.5 6L0 0H9Z" fill="#CC7A29" />
          </svg>

          <div className={styles.coordinates}>
            {gsapLabels?.photography.map((item, index) => (
              <div
                style={
                  {
                    "--shadow-v60-nav-scroll-percent": item,
                  } as React.CSSProperties
                }
                onClick={() => {
                  gsap.to(window, {
                    scrollTo: props.containerAnimation?.parent?.scrollTrigger?.labelToScroll(
                      `photography-scroll-${index}`
                    ),
                  });
                }}
              >
                <div className={styles.rect}></div>
                <div className={styles.line}></div>
                <div className={styles.previewBox}>
                  <Image
                    className={styles.previewImage}
                    src={props.photographyData[index].preview as string}
                  ></Image>
                </div>
                {/* <Text figmaStyle="note">{index}</Text> */}
              </div>
            ))}

            {gsapLabels.ctn.map((item, index) => (
              <div
                style={
                  {
                    "--shadow-v60-nav-scroll-percent": item,
                  } as React.CSSProperties
                }
                onClick={() => {
                  gsap.to(window, {
                    scrollTo: props.containerAnimation?.parent?.scrollTrigger?.labelToScroll(
                      `ctn-scroll-${index}`
                    ),
                  });
                }}
              >
                <div className={`${styles.rect} ${styles.ctnRect}`}></div>
                <div className={styles.line}></div>
                <div className={styles.previewBox}>
                  <div className={styles.previewSomeText}>
                    {`${props.author[index]} · ${props.category[index]}`}
                  </div>
                </div>
                {/* <Text figmaStyle="note">{index}</Text> */}
              </div>
            ))}

            <div
              className={styles.start}
              onClick={() => {
                gsap.to(window, {
                  scrollTo: props.containerAnimation?.parent?.scrollTrigger?.labelToScroll(
                    `start`
                  ),
                });
              }}
            >
              <div className={`${styles.rect} ${styles.startRect}`}></div>
              <div className={styles.line}></div>
            </div>
            <div
              className={styles.end}
              onClick={() => {
                gsap.to(window, {
                  scrollTo: props.containerAnimation?.parent?.scrollTrigger?.labelToScroll(
                    `end`
                  ),
                });
              }}
            >
              <div className={`${styles.rect} ${styles.endRect}`}></div>
              <div className={styles.line}></div>
            </div>
          </div>
        </div>
      </div>
    );
  }
);

export default Navigation;
